module.exports = __webpack_public_path__ + "static/media/cone-fill.4ec4b48c.svg";